var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 332,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.586 330.586l330-330L332 2 2 332l-1.414-1.414z",
    fill: "url(#line_svg__paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "line_svg__paint0_linear",
    x1: -0.501,
    y1: 333.999,
    x2: 328.499,
    y2: 4.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    stopColor: "#B3CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F5"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMyIiBoZWlnaHQ9IjMzMiIgdmlld0JveD0iMCAwIDMzMiAzMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC41ODU3ODEgMzMwLjU4NkwzMzAuNTg2IDAuNTg1Nzg2TDMzMiAyTDEuOTk5OTkgMzMyTDAuNTg1NzgxIDMzMC41ODZaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXIiIHgxPSItMC41MDExNjkiIHkxPSIzMzMuOTk5IiB4Mj0iMzI4LjQ5OSIgeTI9IjQuNDk4NTUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agb2Zmc2V0PSIwLjAyNDY5OTkiIHN0b3AtY29sb3I9IiNGNUY1RjUiLz4KPHN0b3Agb2Zmc2V0PSIwLjUyMzY4NSIgc3RvcC1jb2xvcj0iI0IzQ0JGRiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGNUY1RjUiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgLine as ReactComponent };